import backend from './backend';
import {toBase64, toNumericId} from './utils'
const endpoint = '/products';


export default {
    get(perPage, cursor='', direction='next'){
        return backend.get(endpoint + `?perPage=${perPage}&cursor=${cursor}&direction=${direction}`).then(
            response => response.data
        );
    },

    getProduct(productId){
        return backend.get(`${endpoint}/${toNumericId(productId)}`).then(response => response.data);
    },

    put(productId, data) {
        return backend.put(`${endpoint}/${toNumericId(productId)}`, data)
    },

    addProduct(data) {
        return backend.post(endpoint, data)
    },

    putVariant(productId, variantId, data) {
        return backend.put(`/products/${toNumericId(productId)}/variants/${toNumericId(variantId)}`, data)
    },

    addVariant(productId, data){
        return backend.post(`/products/${toNumericId(productId)}/variants`, data)
    },
    getVariants(productId) {
        return backend.get(`/products/${toNumericId(productId)}/variants`)
    },
    removeVariant(productId, variantId) {
        return backend.delete(`/products/${toNumericId(productId)}/variants/${toNumericId(variantId)}`)
    },
    addImage(productId, data, filename, alt) {
        return toBase64(data).then(encodedData => backend.post(`/products/${toNumericId(productId)}/images`, {data: encodedData, filename: filename, alt: alt}))
    },
    putImage(productId, imageData) {
        return backend.put(`/products/${toNumericId(productId)}/images/${toNumericId(imageData.id)}`, {
            image: {
                ...imageData,
                id: toNumericId(imageData.id)
            }
        })
    },
    removeImage(imageId, productId) {
        return backend.delete(`/products/${toNumericId(productId)}/images/${toNumericId(imageId)}`)
    },
    addOption(productId, optionName, optionValues){
        return backend.post(`/products/${toNumericId(productId)}/options`, {name: optionName, values: optionValues})
    },
    updateOption(productId, optionId, optionName, optionValues = []){
        return backend.put(`/products/${toNumericId(productId)}/options/${toNumericId(optionId)}`, {
            name: optionName,
            values: optionValues
        })
    },
    removeOption(productId, optionName){
        return backend.delete(`/products/${toNumericId(productId)}/options/${optionName}`)
    },
    addToCollection(productId, collectionId){
        return backend.post(`/products/${toNumericId(productId)}/collections`, {'collectionId': collectionId})
    },
    removeFromCollection(productId, collectionId) {
        return backend.delete(`/products/${toNumericId(productId)}/collections/${toNumericId(collectionId)}`)
    },
    addTagToAllProducts(tagName) {
        return backend.post('/products/add_tag', {tag: tagName})
    },
    deleteProduct(productId) {
        return backend.delete(`${endpoint}/${toNumericId(productId)}`)
    }
}
